import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@material-ui/core";
import MovieIcon from "@material-ui/icons/Movie";
import { getEmbededDetails } from "adapters";
import { FileReader } from "components/shared/file-reader";
import { Input } from "components/shared/input";
import { Fragment, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { UploadType } from "store/url-builder";
import * as yup from "yup";

const schema = yup.object().shape({
  fileUrl: yup.string().url().required().label("File URL"),
});

interface FormValues {
  fileUrl: string;
}

export interface EmbededFileImportProps {
  onFileChanged: (file: UploadType) => void;
}

export const EmbededFileImport = ({
  onFileChanged,
}: EmbededFileImportProps) => {
  const [selectedFile, setSelectedFile] = useState<UploadType | null>();
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues: {
      fileUrl: "",
    },
  });

  const submit = async ({ fileUrl }: FormValues) => {
    const file = (await getEmbededDetails(fileUrl)).data.data;

    if (
      file &&
      (file.mimeType.includes("video") ||
        (!file.mimeType.includes("image") &&
          ![
            "png",
            "jpg",
            "jpeg",
            "pdf",
            "svg",
            "gif",
            "ai",
            "eps",
            "raw",
            "indd",
            "tiff",
          ].includes(
            file?.fileUrl.slice(
              file?.fileUrl?.lastIndexOf(".") + 1,
              file?.fileUrl?.length
            )
          )))
    ) {
      onFileChanged(file);
      setSelectedFile(file);
    } else toast.error("Please enter a valid video url");
  };

  return (
    <>
      <Controller<FormValues>
        control={control}
        name="fileUrl"
        render={({ field: { onChange, value } }) => (
          <Fragment>
            <Box
              sx={{ paddingBottom: 10, fontStyle: "italic" }}
              style={{ opacity: 0.7 }}
            >
              Please provide a video URL, the thumbnail image will be populated
              automatically.
            </Box>
            <Input
              className="mb-3"
              label="Please enter url path"
              onChange={(e: any) => {
                if (e.currentTarget.value.length === 0) setSelectedFile(null);
                onChange(e);
                handleSubmit(submit)();
              }}
              value={value}
              error={!!errors.fileUrl}
              helperText={errors.fileUrl?.message}
              fullWidth
            />
          </Fragment>
        )}
      />
      <Box height="auto" minHeight="20em" display="grid">
        {selectedFile && (
          <FileReader file={selectedFile} videoConfig={{ controls: true }} />
        )}
        {!selectedFile && (
          <Box
            sx={{
              height: "100%",
              minHeight: "20em",
              border: "2px dashed #C4C4C4",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MovieIcon fontSize="large" opacity={0.6} />
          </Box>
        )}
      </Box>
    </>
  );
};
